import React from "react";
import logoBlack from "../assets/logo-black.png";
// import { AiOutlineDown, AiOutlineUp } from "react-icons/ai";

const PrivacyPolicy = () => {
  return (
    <div style={styles.page}>
      {/* ✅ HEADER */}
      <div style={styles.header}>
        <img
          src={logoBlack}
          alt="Conquer Life Logo"
          style={styles.logo}
        />
        <h1 style={styles.headerTitle} className="text-big-heading">CONQUER LIFE</h1>
      </div>
      {/* ✅ CONTENT */}
      <div style={styles.container}>
        <h1 style={styles.heading} className="text-big-heading">Privacy Policy</h1>
        <p className="text-body">
          <strong>Effective Date:</strong> <em>13th October 2026</em>
        </p>
        <p className="text-body">
          Welcome to the Conquer Life Privacy Policy! This Policy explains how
          we collect, store, protect, and share your information, and with whom
          we share it. We recommend that you read this alongside our Terms &
          Conditions of Use. While you're enjoying the Conquer Life mobile
          application (available on iOS and Android platforms) or our Conquer
          Life website (together referred to in this Privacy Policy as our
          "Sites"), we collect some information about you. Additionally, you may
          choose to use the App or Sites to share information with other users,
          including your friends and contacts ("Users"). There may also be
          instances where we need to share your information. The App and Sites
          are based in the United States, and all collected information will be
          used within the United States. This Policy outlines how we protect
          your personal data within this jurisdiction, so please read carefully!
        </p>
        <h2 className="text-heading">Who We Are</h2>
        <p className="text-body">
          The Conquer Life app and Conquer Life website are operated by "Conquer
          Life Co." (referred to in this policy as “we” or “us”), which is the
          sole controller of personal information collected and processed
          through our App and Sites.
        </p>
        <p className="text-body">
          Although we do not have a designated Data Protection Officer, users
          can reach out to us through the Feedback page within our App for any
          concerns or inquiries regarding their personal data.
        </p>
        <h2 className="text-heading">Collection Of Information</h2>
        <h3 className="text-sub-heading">Registration Information</h3>
        <p className="text-body">
          When you download the Conquer Life app and create an account
          (“Account”), we collect certain information (“Registration
          Information”) about you, such as:
        </p>
        <ul>
          <li>
            Email address or mobile number (depending on your chosen sign-up
            method)
          </li>
          <li>Username</li>
          <li>Areas of interest</li>
          <li>
            Personality details, including but not limited to information about
            sports you play, music you like, self-characteristics, home life,
            thoughts, feelings, and expressions, culture, and nations.
          </li>
        </ul>
        <p className="text-body">
          You can review your registration information and use the available
          account controls to keep your details up to date. For help with your
          registered email address or phone number, contact us at{" "}
          <a href="mailto:info@conquerlife.io">info@conquerlife.io</a>.
        </p>
        <p className="text-body">
          The information we collect helps to enhance the app and verify our
          users. We also use registration information to prepare and deliver
          activity reminders, as explained under Use Of Information below.
          Registration information such as your username and areas of interest
          may be visible to other users who view your profile page.
        </p>
        <p className="text-body">
          For users who are California residents, the data we may collect falls
          within the following categories of “personal information,” as defined
          by the California Consumer Privacy Act (CCPA):
        </p>
        <ul>
          <li>
            Identifiers, such as email address, mobile number, and username;
          </li>
          <li>
            Personal information, as defined in the California customer records
            law, such as contact (including email and telephone number);
          </li>
          <li>
            Characteristics of protected classifications under California or
            federal law (if you choose to provide them), such as age, gender
            identity, sexual orientation, race, and medical conditions;
          </li>
          <li>
            Internet or network activity information, such as interactions with
            our app;
          </li>
          <li>
            Audio, electronic, visual, and similar information, such as
            information you may voluntarily provide in your profile;
          </li>
          <li>
            Professional or employment-related information, such as work history
            and prior employer;
          </li>
          <li>
            Inferences drawn from any of the personal information listed above
            to create a profile or summary about, for example, an individual’s
            preferences and characteristics.
          </li>
        </ul>
        <h3 className="text-sub-heading">Profile Information</h3>
        <p className="text-body">
          We recommend and encourage you to think carefully about the
          information you disclose about yourself. We do not recommend that you
          put email addresses, URLs, instant messaging details, phone numbers,
          full names or addresses, credit card details, national identity
          numbers, driver’s license details, and other sensitive information
          which is open to abuse and misuse on your profile.
        </p>
        <p className="text-body">
          When you post information about yourself or use the messaging function
          to communicate with other users, the amount of personal information
          you share is at your own risk.
        </p>
        <h3 className="text-sub-heading">Profile Verification Information</h3>
        <p className="text-body">
          For safety and security and to ensure you have the best possible user
          experience, we require users to verify their accounts via the email
          address or phone number provided during sign-up. This is to help
          ensure that you are who you say you are and to prevent fake accounts
          from being created, which can be used for malicious activities.
        </p>
        <h3 className="text-sub-heading">Device Information</h3>
        <p className="text-body">
          We may collect information about your device when you use the Conquer
          Life app, including the unique device identifier, device model, IP
          address, and browser type. This information is collected to help us
          keep track of user sessions, maintain the security of our app, and
          enhance the user experience.
        </p>
        <h3 className="text-sub-heading">Purchases Information</h3>
        <p className="text-body">
          At this time, Conquer Life does not offer any premium services or
          in-app purchases. As such, no payment information is collected or
          processed.
        </p>
        <h3 className="text-sub-heading">Geolocation Information</h3>
        <p className="text-body">
          Conquer Life does not currently collect or use geolocation data. If
          this changes in the future, we will update our Privacy Policy
          accordingly.
        </p>
        <h3 className="text-sub-heading">Photos Information</h3>
        <p className="text-body">
          We do not collect any photos from your devices. The app does not
          request access to your device’s camera roll or photo library.
        </p>
        <h3 className="text-sub-heading">Links</h3>
        <p className="text-body">
          We may keep track of how you interact with links available within the
          Conquer Life app, including third-party services by redirecting clicks
          or through other means. We may share aggregate click statistics such
          as how many times a particular link was clicked on.
        </p>
        <h3 className="text-sub-heading">Surveys and Other Contributions</h3>
        <p className="text-body">
          From time to time, we may run surveys for research purposes and may
          contact you to find out if you would like to take part. We may also
          contact you to find out if you would like to provide feedback or a
          testimonial. Such surveys and feedback requests are optional, and more
          information will be provided at the point of contact. If you do not
          wish to be contacted for such purposes, please contact our Customer
          Support Team via our in-app Feedback Page.
        </p>
        <h3 className="text-sub-heading">When You Contact Customer Support</h3>
        <p className="text-body">
          If you contact our Customer Support team via our in-app Feedback Page,
          we will receive your email address and may track your IP address, as
          well as the information you send to us to help resolve your query. We
          will keep records of our communications with you, including any
          complaints that we receive from you about other users (and from other
          users about you) for 6 years after the deletion of your account.
        </p>
        <h3 className="text-sub-heading">Cookies and Similar Technologies</h3>
        <p className="text-body">
          Conquer Life does not use cookies or similar tracking technologies. If
          this changes in the future, we will update our Privacy Policy
          accordingly.
        </p>
        <h2 className="text-heading">Use Of Information</h2>
        <p className="text-body">
          Our primary goal at Conquer Life is to provide a safe and enjoyable
          experience for our users, allowing them to express themselves and
          connect with other like-minded humans. To deliver this experience, we
          may use your registration and other information to:
        </p>
        <ul>
          <li>Offer you our services and features.</li>
          <li>
            Contact you with necessary information about the app, including
            updates related to security, safety, legal actions, or other
            important features.
          </li>
          <li>
            Prepare and deliver activity reminders for unread breakout
            messages, unread one-on-one and group chat messages, and kindness
            coins gifted by another user, excluding challenge rewards and other
            system-earned coins.
          </li>
          <li>Personalize the app and the content we deliver to you.</li>
          <li>
            Conduct research and analytics on how you interact with the app.
          </li>
          <li>
            Test new technologies and processes to enhance and improve the app
          </li>
          <li>
            Resolve disputes, troubleshoot problems, and enforce our Terms &
            Conditions.
          </li>
          <li>
            Investigate fraud, protect our legal rights, and safeguard our
            users.
          </li>
          <li>Protect our users and third parties from harm.</li>
        </ul>
        <h3 className="text-sub-heading">Activity Reminders</h3>
        <p className="text-body">
          We use your registered email address or phone number, notification
          preferences, unread-activity information, and gifted-coin totals to
          prepare and deliver grouped activity reminders. The verified contact
          associated with your account determines whether reminders are sent
          by email or, for supported U.S. phone numbers, SMS. Users currently
          register with one contact type; the notification controls do not let
          you switch between email and SMS. Reminders contain activity summaries
          rather than private chat-message bodies.
        </p>
        <p className="text-body">
          Notification preferences and delivery records support notification
          processing, troubleshooting, and duplicate prevention. Settings
          includes a master switch and individual breakout, chat, and
          kindness-coin switches for email/SMS activity reminders. These are
          separate from in-app notifications, push notifications, and login or
          security messages such as OTPs. Turning reminders off in Settings
          does not disable OTPs. SMS STOP requests are enforced separately by
          AWS or mobile carriers and may also block OTPs from the same number;
          turning reminders back on in Settings cannot override those blocks.
        </p>
        <p className="text-body">
          This Policy describes how notification information is used; it does
          not collect consent for activity-reminder SMS. OTP permission is
          separate from permission for activity reminders. The App has not
          implemented a separate activity-reminder SMS opt-in. Signing up,
          logging in, verifying a phone number, accepting policy terms, or a
          default-on Settings switch does not establish that separate
          permission, and this update does not supply permission retroactively.
        </p>
        <h3 className="text-sub-heading">Profile Suggestions</h3>
        <p className="text-body">
          Conquer Life helps users discover new people through a daily set of
          suggested profiles. Suggestions are based on shared interests and
          activity levels. To protect user privacy, we only display profile
          details such as username, profile color, bio, interests list, and
          personality traits—email addresses and phone numbers are not shown.
          Our algorithms may be improved over time to enhance user experience,
          and we will keep our privacy policy updated accordingly.
        </p>
        <h3 className="text-sub-heading">Moderation Practices</h3>
        <p className="text-body">
          We utilize a combination of automated systems and a team of moderators
          to monitor accounts (including photos and any other profile
          information) and messages for content that breaches our Terms &
          Conditions of Use. If content indicates a breach, the relevant account
          may be restricted or blocked, and affected users can contact us to
          contest the decision. If you post anything inconsistent with our Terms
          & Conditions, we reserve the right to terminate or restrict access to
          your account.
        </p>
        <h3 className="text-sub-heading">Safety Tools and User Controls</h3>
        <ul>
          <li>Users can report messages and profiles in-app </li>
          <li>Users can block other users </li>
          <li>Users can end chat anytime</li>
          <li>We review reports promptly and take action when appropriate. </li>
          <li>We enforce community guidelines </li>
        </ul>
        <h3 className="text-sub-heading">Lawful Basis</h3>
        <p className="text-body">
          We process user data under U.S. data protection laws, primarily based
          on the following legal bases:
        </p>
        <ul>
          <li>
            Contractual Necessity: For providing the Conquer Life app services,
            including profile discovery and messaging features.
          </li>
          <li>
            Legitimate Interests: For improving the app, ensuring user safety,
            preventing fraud, and analyzing how users interact with the app. We
            may also process data for troubleshooting, research, and app
            enhancements.
          </li>
          <li>
            Consent: We may process sensitive personal information based on your
            explicit consent, such as when you choose to share specific details
            in your profile.
          </li>
        </ul>
        <h3 className="text-sub-heading">Processing We Perform to Improve Services for Our Users</h3>
        <p className="text-body">
          <b>What we’re doing:</b> We process personal data to enhance user
          experiences and ensure that interactions within the app are positive
          and safe. This includes using text analyzers to detect and prevent
          inappropriate messages that could cause emotional or any other harm.
        </p>
        <p className="text-body">
          <b>What we don’t do:</b> We do not track your real-time movements or
          identify your precise location for these purposes.
        </p>
        <p className="text-body">
          <b>Why we’re doing this:</b> To create a safer and more tailored app
          experience for all users. We will continue to improve the app's
          features and will update this privacy policy as needed to reflect any
          changes.
        </p>
        <h2 className="text-heading">Disclosure Of Information</h2>
        <p className="text-body">
          Our policy is to not disclose your Registration Information or
          personal data, except in the limited circumstances described here:
        </p>
        <h4 className="text-sub-heading">Circumstances where data may be disclosed: </h4>
        <p className="text-body">
          <b>Moderators –</b> To monitor activity on the App and approve
          content. Name and user registration details, profile information,
          content of messages and photographs.
        </p>
        <p className="text-body">
          <b>Law and Harm – </b> We believe it is important for all Users to
          behave appropriately while using the App. We will cooperate with
          lawfully made law enforcement requests for information within or
          outside your country of residence when required by law. This may
          include investigations into alleged criminal behavior or to protect
          the vital interests of a person. We may preserve or disclose any of
          your information, including your Registration Information, if we
          believe in good faith that it is necessary to comply with a law or
          regulation, or when we believe in good faith that disclosure is
          necessary:
        </p>
        <ul>
          <li>
            to comply with a binding direction, court order, or lawful request;
          </li>
          <li>to protect the safety of any person;</li>
          <li>
            to address fraud, security, or technical issues (e.g., through
            anti-spam measures) to protect the service from criminal activity;
            or
          </li>
          <li>to protect our rights or property or those of third parties.</li>
        </ul>
        <p className="text-body">
          In such cases, we may raise or waive any legal objection or right
          available to us. This could include any personal data that Conquer
          Life holds about you, depending on the nature of the request or the
          issue that we are dealing with.
        </p>
        <p className="text-body">
          <b>Business Transfers –</b>
          In the event that Conquer Life or any of its assets undergoes a
          business transition or change of ownership, such as a merger,
          acquisition by another company, re-organization, or sale of all or a
          portion of its assets, or in the event of insolvency or
          administration, we may be required to disclose your personal data.
          This could include all personal data that Conquer Life holds about
          you.
        </p>
        <p className="text-body">
          <b>Aggregated Information –</b>
          We may share aggregated information with third parties that includes
          your personal data (but which doesn’t identify you directly) together
          with other information including log data for industry analysis and
          demographic profiling.
        </p>
        <p className="text-body">
          <b>Note:</b> We use service providers for app operations and
          notification delivery, as described below.
        </p>
        <h2 className="text-heading"> More Information About Disclosures</h2>
        <h4 className="text-sub-heading">Service Providers</h4>
        <p className="text-body">
          We engage certain trusted third parties to perform functions and
          provide services to us ("Service Providers"). Conquer Life uses
          Amazon Web Services (AWS) for application hosting infrastructure,
          related services, and SMS delivery through Amazon Simple Notification
          Service (SNS). Email activity reminders are delivered through our
          configured email service provider using SMTP.
          {/* Publication review: confirm and name the deployed SMTP provider;
              the available source identifies configuration, not the provider. */}
        </p>
        <p className="text-body">
          We share the contact details and notification information necessary
          for delivery with the providers involved, including the recipient’s
          email address with the email delivery provider, or phone number with
          AWS and relevant mobile carriers, together with the reminder summary
          and information needed to process and track delivery. Delivery
          requires identifiable contact details; private chat-message bodies
          are not included in activity reminders.
        </p>
        <h4 className="text-sub-heading">Marketing Services Providers </h4>
        <p className="text-body">
          At this time, Conquer Life does not partner with any marketing
          services providers and has no connection with Facebook or similar
          platforms. We do not use any external services for marketing,
          advertising, or measuring the effectiveness of campaigns. Should this
          change in the future, we will update our privacy policy with detailed
          information regarding the services used and the data shared.
        </p>
        <p className="text-body">
          For more information about how we use cookies and other tracking
          technologies, including how you can set and manage your preferences
          with regards to such technologies, please refer to our Cookie Policy.
        </p>
        <h2 className="text-heading">What Others May See About You</h2>
        <p className="text-body">
          We believe our users are incredible, and we want to provide a platform
          where you can share your authentic self with others. The Conquer Life
          app is designed to facilitate meaningful connections and interactions
          between users.
        </p>
        <p className="text-body">
          When using the Conquer Life app, please be aware that certain profile
          details you provide will be visible to other users. These details
          include your username, profile color, interests, personality traits,
          and the content of your "About" or bio section. Although the app does
          not currently offer features for posting content or updates, the
          information you choose to share in your profile can still be viewed by
          others on the platform.
        </p>
        <p className="text-body">
          We encourage users to feel comfortable expressing their true selves
          while maintaining privacy and ensuring a safe environment for all.
          It’s important to remember that, while you may feel free to share
          personal information in your profile, you should be mindful of the
          potential implications of doing so. Please avoid sharing sensitive
          details that could identify you outside of the app or could cause harm
          to yourself or others.
        </p>
        <p className="text-body">
          Conquer Life does not allow the integration of third-party accounts,
          such as Facebook, Instagram, or Spotify, and there are no features to
          link or share your profile information through external platforms.
          This helps to ensure that your activity within Conquer Life remains
          within the app.
        </p>
        <p className="text-body">
          Finally, if you share a device with others, please ensure you log out
          of your Conquer Life account after each session to maintain your
          privacy and security.
        </p>
        <h2 className="text-heading">Our Policy Towards Age</h2>
        <p className="text-body">
          While we aim to create a space for as many people as possible to enjoy
          the Conquer Life experience, our app is intended for users who are at
          least 18 years old.
        </p>
        <p className="text-body">
          Conquer Life does not knowingly collect any information about or
          market to individuals under the age of 18. If we become aware that
          someone under the age of 18 has registered with us and provided
          personal information, we will take immediate steps to terminate that
          person's registration and delete their information from our systems.
        </p>
        <h2 className="text-heading">Security</h2>
        <p className="text-body">
          At Conquer Life, we are committed to taking all appropriate security
          measures to help protect your information against loss, misuse,
          unauthorized access, or disclosure. We use reasonable security
          measures such as secured servers with firewalls to safeguard the
          confidentiality of your personal information.
        </p>{" "}
        <p className="text-body">
          Unfortunately, no website or Internet transmission is ever completely
          secure, and we cannot guarantee that unauthorized access, hacking,
          data loss, or other breaches will never occur. However, here are some
          handy tips to help keep your data secure:
        </p>
        <ul>
          <li>Log out on shared devices</li>
          <li>Do not share your password</li>
          <li>Change password periodically</li>
          <li>
            If your account is compromised, visit{" "}
            <a
              href={process.env.REACT_APP_CONQUER_LIFE_FAQ_URL || "/faq"}
              target="_blank"
              rel="noopener noreferrer"
            >
              Frequently Asked Questions (FAQ)
            </a>{" "}
            for next steps.
          </li>
        </ul>
        <p className="text-body">
          While we strive to protect your personal data, we cannot guarantee its
          security during transmission to our site, and any transmission is at
          your own risk.
        </p>
        <h2 className="text-heading">Linking Other Accounts To Conquer Life</h2>
        <p className="text-body">
          The Conquer Life app is designed to be a safe space where users can
          communicate using usernames and privacy-protective profiles. To
          maintain this environment, we do not provide any connection with other
          social media platforms, such as Facebook, Instagram, or Spotify.
        </p>
        <p className="text-body">
          Our goal is to ensure that your interactions within the Conquer Life
          app remain private and free from external influences. Therefore, you
          cannot sign in to Conquer Life using social media accounts, nor can
          you link your Conquer Life account to any social media platforms.
        </p>
        <p className="text-body">
          We believe that this approach helps protect your identity and fosters
          a more genuine and secure communication space within our app.
        </p>
        <h2 className="text-heading">Your California Privacy Rights</h2>
        <p className="text-body">
          For Users who are California residents, you have the following rights
          under the California Consumer Privacy Act (CCPA), in addition to any
          other rights listed in this Privacy Policy. You also have the right to
          be free from unlawful discrimination for exercising your rights under
          the CCPA:
        </p>
        <ul>
          <li>
            <b>Right to Know:</b> You have the right to request that we disclose
            certain information to you and explain how we have collected, used,
            and shared your personal information over the past 12 months.
          </li>

          <li>
            <b>Right to Delete:</b> You have the right to request that we delete
            your personal information that we have collected from you, subject
            to certain exceptions.{" "}
          </li>

          <li>
            <b>“Shine the Light” Law:</b> California’s “Shine the Light” law,
            Civil Code section 1798.83, requires certain businesses to respond
            to requests from California customers asking about the businesses’
            practices related to disclosing personal information to third
            parties for the third parties’ direct marketing purposes. Since
            Conquer Life currently does not share personal information with
            third parties for their direct marketing purposes, there are no such
            disclosures to report. If you wish to learn more about your rights
            under California Civil Code section 1798.83, you can write to us
            using the in App Feedback section.{" "}
          </li>

          <li>
            <b>Do Not Track:</b> At this time, we do not track our Users’
            personal information over time and across third-party online
            services. Furthermore, we do not knowingly permit third parties to
            collect personal information about an individual User’s online
            activities over time and across different online services when using
            the Conquer Life app.{" "}
          </li>
        </ul>
        If you wish to exercise any of your rights under the CCPA, or have any
        questions about your rights and how they apply to your use of the
        Conquer Life app, please contact us using the in App Feedback section.
        <h2 className="text-heading">Your Rights</h2>
        <p className="text-body">
          Depending on the privacy laws applicable in your country, you may have
          the following rights:
        </p>
        <ul>
          <li>
            <b>Right to be informed:</b> You have the right to know what
            personal data an organization is processing and why (as detailed in
            this Privacy Policy).
          </li>
          <li>
            <b>Right of access:</b> You can request a copy of your data.
          </li>
          <li>
            <b>Right of rectification:</b> If the data held is inaccurate, you
            have the right to have it corrected.
          </li>
          <li>
            <b>Right to erasure:</b> You have the right to have your data
            deleted in certain circumstances.
          </li>
          <li>
            <b>Right to restrict processing:</b> In limited circumstances, you
            have the right to request that processing is stopped but the data is
            retained.
          </li>
          <li>
            <b>Right to data portability:</b> You can request a copy of certain
            data in a machine-readable form that can be transferred to another
            provider.
          </li>
          <li>
            <b>Right to object:</b> In certain circumstances (including where
            data is processed on the basis of legitimate interests or for the
            purposes of marketing), you may object to that processing.
          </li>
          <li>
            <b>
              Rights related to automated decision-making including profiling:
            </b>{" "}
            If processing carried out on a solely automated basis results in a
            decision that has legal or significant effects for you, your rights
            include the right to ensure human intervention in the
            decision-making process.
          </li>
        </ul>
        <p className="text-body">
          The specific rights applicable to you may vary depending on your
          country. It is important to familiarize yourself with the rights you
          have under the applicable privacy laws in your country.
        </p>
        <p className="text-body">
          If you want to exercise any of your rights listed above, please reach
          out to us via the in-app Feedback Section. We are based in the United
          States, and all data is processed within the United States.
        </p>
        <p className="text-body">
          For any issues or concerns regarding your data, you can contact us
          through the in-app Feedback Section. Our team will respond based on
          the severity of your communication and the time required for our
          internal investigation.
        </p>
        <h2 className="text-heading">Data Locations</h2>
        <p className="text-body">
          Conquer Life is accessible globally, allowing you to use the app
          wherever you are in the world. Currently, all data is processed within
          the United States. Should there be any changes to our data processing
          locations in the future, for enhanced user experience or operational
          reasons, we will update our Privacy Policy accordingly.
        </p>
        <p className="text-body">
          If you have any concerns or issues to report, please reach out to us
          via the in-app Feedback Section.
        </p>
        <h2 className="text-heading">Data Retention & Deletion</h2>
        <p className="text-body">
          We retain your personal information, such as email, phone number, and
          profile details, only as long as your profile exists within our app.
        </p>
        <p className="text-body">
          If you choose to delete your account, all personal information
          associated with your profile, except for your profile color, will be
          permanently removed from our app. Your profile will no longer be
          visible to other users, and it cannot be restored once deleted.
        </p>
        <p className="text-body">
          Please be aware that while we remove your data from our systems,
          copies of information may still be accessible if it has been
          previously shared with others or stored by third parties. We cannot
          control or accept liability for such instances. If you have granted
          third-party applications or websites access to your personal
          information, they may retain it according to their own terms of
          service or privacy policies.
        </p>
        <p className="text-body">
          Thank you for taking the time to read this! We hope you find this
          information helpful and easy to understand. If you have any questions,
          feel free to reach out!
        </p>
        <h2 className="text-heading">Changes To This Policy</h2>
        <p className="text-body">
          As Conquer Life evolves, we may update this Privacy Policy from time
          to time. The latest version of the policy will always be available on
          our website at the Privacy Policy page. If we make any significant
          changes to this policy, we will notify you, for example, via email to
          the address associated with your account or by posting a notice within
          the app.
        </p>
        <h2 className="text-heading">Contact Us</h2>
        <p className="text-body">
          For privacy concerns, contact us via Feedback Section or email{" "}
          <a href="mailto:info@conquerlife.io">info@conquerlife.io</a>.
        </p>
        <p className="text-body">
          <strong>
            <em>Conquer Life Co.</em>
          </strong>
        </p>
      </div>
    </div>
  );
};

const styles = {
  page: {
    flex: 1,
    backgroundColor: "#FFFFFF",
  },
  header: {
    display: "flex",
    alignItems: "center",
    borderBottom: "1px solid black",
    height: "60px",
    padding: "0 15px",
    boxSizing: "border-box",
  },
  logo: {
    width: "40px",
    height: "40px",
    marginRight: "15px",
  },
  headerTitle: {
    fontSize: "26px",
    fontWeight: "bold",
    color: "black",
    margin: 0,
  },
  container: {
    padding: "2rem",
  },
  heading: {
    textAlign: "center",
    fontSize: "2.5rem",
    color: "#333",
    marginBottom: "2rem",
  },
};

export default PrivacyPolicy;
